export const NEGOTIATION_BOT_OPEN_EVENT = "bidz:open-negotiation-bot";

export const openNegotiationBotInChat = (payload = {}) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(NEGOTIATION_BOT_OPEN_EVENT, {
      detail: payload,
    }),
  );
};
